import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{ focus?: boolean; disabled?: boolean }> = ({
  focus,
  disabled,
}) => ({
  height: (p) => p.spacing(4.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingX: 1,
  borderRadius: 1,
  backgroundColor: focus ? (p) => p.palette.grey[100] : 'inherit',
  ':hover': {
    cursor: !disabled ? 'pointer' : 'default',
    backgroundColor: (p) => p.palette.grey[100],
  },
});
